// extracted by mini-css-extract-plugin
export var activityContainer = "_i4-0";
export var typingIndicatorContainer = "_i4-1";
export var typingIndicatorDot = "_i4-2";
export var wave = "_i4-3";